var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaby8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-266 -4091)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(266 4091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280 4061.178)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 47.822)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.72 23.466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.413,354.634a6.39,6.39,0,0,0-5.021-2.434l-6.274,5.035,1.051,1.072,1.343,1.37h7.76l2.394-2.441A6.5,6.5,0,0,0,178.413,354.634Z",
    transform: "translate(-166.954 -352.2)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.937,418.974v.982h-2.558v-.982a6.6,6.6,0,0,0-.037-.7,16.891,16.891,0,0,0,2.432-.757A6.537,6.537,0,0,1,300.937,418.974Z",
    transform: "translate(-288.06 -412.48)",
    fill: "#ffddcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.391,352.2a6.408,6.408,0,0,0-5.021,2.434,6.5,6.5,0,0,0-1.254,2.6l1.051,1.072,1.381-.314a6.494,6.494,0,0,1,5.121-5.664A6.383,6.383,0,0,0,173.391,352.2Z",
    transform: "translate(-166.953 -352.201)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.992,418.974v.982h2.558v-.982a6.6,6.6,0,0,1,.037-.7,16.89,16.89,0,0,1-2.432-.757A6.538,6.538,0,0,0,164.992,418.974Z",
    transform: "translate(-164.992 -412.48)",
    fill: "#ffcbbe"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.105 0.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.352,174.42H56.239a3,3,0,1,0,0,5.995H80.352a3,3,0,1,0,0-5.995Z",
    transform: "translate(-53.242 -165.427)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.185,57.776h-4.016L92.121,69.665l10.048,11.889h4.016a12.057,12.057,0,0,0,0-23.778Z",
    transform: "translate(-92.121 -57.776)",
    fill: "#ffddcf"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.119,177.334a12.1,12.1,0,0,1,.354-2.913h-4a12.062,12.062,0,0,0,13.713,14.785A12.038,12.038,0,0,1,96.119,177.334Z",
    transform: "translate(-92.12 -174.421)",
    fill: "#ffcbbe"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.638,69.589q-.174-.191-.358-.376A10.624,10.624,0,0,0,1.272,66.394,1.661,1.661,0,0,0,.057,68.44l1.018,3.8a1.67,1.67,0,0,0,2.5.991A10.624,10.624,0,0,1,10,71.616,10.884,10.884,0,0,1,11.638,69.589Z",
    transform: "translate(0 -66.099)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.448,66.394a10.624,10.624,0,0,0-10.008,2.819q-.183.183-.355.372.364.353.7.741a10.779,10.779,0,0,1,.946,1.29,10.624,10.624,0,0,1,6.42,1.615,1.67,1.67,0,0,0,2.5-.991l1.018-3.8A1.661,1.661,0,0,0,356.448,66.394Z",
    transform: "translate(-319.403 -66.099)",
    fill: "#463c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.16,62.861a12.634,12.634,0,0,0-3.565-5.366,1.575,1.575,0,0,0-1.064-.391h-.4a1.591,1.591,0,0,0-.814-1.225,12.617,12.617,0,0,0-2.467-1.042H152.5l-4.043,3.822h0v5.4h.831a16.615,16.615,0,0,0,11.748-4.866l3.782,3.782a3.7,3.7,0,0,0,2.618,1.084h.44A1.163,1.163,0,0,0,168.16,62.861Z",
    transform: "translate(-144.124 -54.296)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.374,48a12.8,12.8,0,0,0-4.218,0,12.644,12.644,0,0,0-9.879,8.39,1.162,1.162,0,0,0,.282,1.195h3.993a11.837,11.837,0,0,1,9.711-9c.463-.066,1.032-.142,1.676-.224A12.636,12.636,0,0,0,106.374,48Z",
    transform: "translate(-92.216 -47.822)",
    fill: "#463c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.766 13.466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.129,222.484a.578.578,0,0,0-.578.578v.925a.578.578,0,1,0,1.156,0v-.925A.578.578,0,0,0,179.129,222.484Z",
    transform: "translate(-178.551 -222.484)",
    fill: "#313d40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.027,222.484a.578.578,0,0,0-.578.578v.925a.578.578,0,1,0,1.156,0v-.925A.578.578,0,0,0,304.027,222.484Z",
    transform: "translate(-293.82 -222.484)",
    fill: "#313d40"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby8);
export default __webpack_public_path__ + "static/media/baby8.7cc50a1f8d81c20fdc668f9633b7d8e2.svg";
export { ForwardRef as ReactComponent };